import Container = PIXI.Container;
import Application = PIXI.Application;
import {BuildEnvironments, EnvironmentSettings} from '../../settings/Environment';

export class SceneManager {
    private static _instance: SceneManager;

    public readonly _app: Application;
    public readonly stage: Container;
    public static readonly gameWidth: number = 1060;
    public static readonly gameHeight: number = 600;
    public static readonly buttonY: number = 620;
    private stats: Stats;

    private constructor() {
        this._app = new Application({
            transparent: true,
            width: SceneManager.gameWidth,
            height: SceneManager.gameHeight,
            // backgroundColor: 0x000000,
            resolution: window.devicePixelRatio || 1,
        });
        this.stage = this._app.stage;
        const wrapper: any = document.getElementById('wrapper');
        wrapper.appendChild(this._app.view);

        if (EnvironmentSettings.BUILD_ENVIRONMENT === BuildEnvironments.DEV) {
            // this.stats = new Stats();
            // this.stats.showPanel(0);
            // this.stats.domElement.id = 'statsDomElement';
            // document.body.appendChild(this.stats.domElement);
            // // this.gameLoop();
        }
    }

    public static getInstance(): SceneManager {
        return SceneManager._instance || (this._instance = new this());
    }

    public getJson(name: string): any {
        return this._app.loader.resources['assets/json/' + name + '.json'].data;
    }

    private animateStats(): void {
        this.stats.begin();
        this.stats.end();
    }
}